import React, { useEffect, useRef, useState } from "react";
import { Portal } from "react-native-alves-portal";
import Animated, { 
  useSharedValue, 
  useAnimatedStyle, 
  withTiming, 
  Easing, 
  runOnJS 
} from "react-native-reanimated";
import { Box, Button, Pressable, Text, View } from "native-base";
import FastImage from "@d11/react-native-fast-image";
import { PorfolioList } from "../../../Universal/API/Context-API/AppProvider";
import { useAppContext } from "../../../Universal/API/Context-API/AppContext";

export interface PortfolioExpansionProps {
  visible: boolean;
  onClose: () => void;
  portfolio: PorfolioList;
  position: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
}

import Carousel, { Pagination } from "react-native-reanimated-carousel";
import { PressableWrap } from "../../../Universal/Buttons/PressableColorWrap/PressableColorWrap";

import { HugeiconsIcon } from '@hugeicons/react-native';
import { ArrowDown01Icon, ArrowUp01Icon, Cancel01Icon, CancelCircleIcon } from '@hugeicons-pro/core-solid-rounded';
import { scaleAll_, verticalScale_ } from "../../../Universal/API/Scale";

import Video from 'react-native-video'
import BottomSheet, { BottomSheetScrollView, BottomSheetView, SNAP_POINT_TYPE } from "@gorhom/bottom-sheet";
import { Gesture, GestureDetector, ScrollView } from "react-native-gesture-handler";
// import { Notification03Icon } from ''
 
const PortfolioExpansion: React.FC<PortfolioExpansionProps> = ({ visible, onClose, portfolio, position }) => {
  const [isMounted, setIsMounted] = useState(false);


  const {currentWidth, currentHeight, isSmallVersion} = useAppContext()
  const animX = useSharedValue(position.x);
  const animY = useSharedValue(position.y);
  const animWidth = useSharedValue(position.width);
  const animHeight = useSharedValue(position.height);
  const animOpacity = useSharedValue(0);

  const target_width = isSmallVersion ? currentWidth: 1000
  const target_height = currentHeight
  useEffect(() => {
    if (visible) {
      setIsMounted(true);
      // Animate in
      animX.value = withTiming(0, { duration: 10000, easing: Easing.out(Easing.exp) });
      animY.value = withTiming(0, { duration: 10000, easing: Easing.out(Easing.exp) });
      animWidth.value = withTiming(target_width, { duration: 400, easing: Easing.out(Easing.exp) });
      animHeight.value = withTiming(target_height, { duration: 400, easing: Easing.out(Easing.exp) });
      animOpacity.value = withTiming(1, { duration: 300 });
      
    }
  }, [visible]);
  const centerX = (currentWidth - target_width) / 2;
  // Create inside component
const dragStartY = useSharedValue(0);
const draggedDownEnough = useSharedValue(false);

const animatedStyle = useAnimatedStyle(() => {
    const translateY = dragStartY.value;
    const opacity = 1 - Math.min(translateY / 300, 0.7); // fade out but not completely (minimum 0.3)
  
    return {
      position: 'absolute',
      zIndex: 1000,
      top: animY.value,
      left: animX.value,
      height: currentHeight,
      width: currentWidth,
      paddingLeft: centerX,
      backgroundColor: 'black',
      borderRadius: 0,
      overflow: 'hidden',
      opacity: animOpacity.value * opacity, // <-- IMPORTANT
      transform: [{ translateY }] // <-- Move down with finger
    };
  });
  

  const animSt = useAnimatedStyle(() => {
    return {
        width: animWidth.value,
        height: animHeight.value,
    }
  })

  const handleClose = () => {
    // Animate back
    animX.value = withTiming(position.x, { duration: 300, easing: Easing.out(Easing.exp) });
    animY.value = withTiming(position.y, { duration: 300, easing: Easing.out(Easing.exp) });
    animWidth.value = withTiming(position.width, { duration: 300, easing: Easing.out(Easing.exp) });
    animHeight.value = withTiming(position.height, { duration: 300, easing: Easing.out(Easing.exp) }, () => {
      runOnJS(setIsMounted)(false);
      runOnJS(onClose)();
    });
    animOpacity.value = withTiming(0, { duration: 200 });
  };
  const [closeHovered, setHovered] = useState(false)
  const [arrowType, setArrowType] = useState<'up' | 'down'>('up')

  const refBottomSheet = useRef<BottomSheet>(null)


  const closeGesture = Gesture.Pan()
  .onStart((event) => {
    dragStartY.value = event.y; // record start point
    draggedDownEnough.value = false;
  })
  .onUpdate((event) => {
    // if (dragStartY.value < 100) { // only if gesture started at top
    //   // Move the view down with the finger
      
    // }
    dragStartY.value = event.translationY > 0 ? event.translationY : 0;
  })
  .onEnd((event) => {
    if (event.translationY > 120) { // check how much user dragged
    //   runOnJS(handleClose)();
        dragStartY.value = withTiming(currentHeight, {duration: 340}, () => {
            runOnJS(setIsMounted)(false);
            runOnJS(onClose)();
        })
    } else {
      dragStartY.value = withTiming(0, { duration: 300 });
    }
  });
  
  const data = [
    ...(portfolio.images.map(image => {
        return (
            {content: image, type: 'i'}
        )
    })),

    ...(portfolio.videos.map(video => {
        return ({
            content: video,
            type: 'v'
        })
    }))
]

const progress = useSharedValue(0)
  if (!isMounted) return null;

  
  return (
    <Portal>
         <GestureDetector gesture={closeGesture}>
      <Animated.View style={[animatedStyle,]}>
        <Animated.View style={animSt}>
        <Box style={{ flex: 1 }} onLayout={() => {console.log('visible')}}>
            <PressableWrap
                style={{position: 'absolute', top: 20, right: 20, 
                    flexDirection: 'row',
                    alignSelf: 'flex-start',
                    // flex: 
                    justifyContent: 'flex-start',
                    width: scaleAll_(32),
                    // backgroundColor: 'red',
                    zIndex: 10000}}
                 onPress={handleClose}
                 onHoverIn={() => {setHovered(true)}}
                 onHoverOut={() => setHovered(false)}
            >
                <Box flex={1} flexDirection={'row-reverse'} display={'flex'} width={'100vh'}>
                    <HugeiconsIcon
                        icon={ Cancel01Icon}
                        size={scaleAll_(32)}
                        color={(closeHovered ? "rgb(95, 190, 245)": 'white')}
                    />
                </Box>
            </PressableWrap>
        <Box>
            <Pagination.Basic
                data={data}
                progress={progress}
                dotStyle={{ backgroundColor: "rgba(0,0,0,0.4)", borderRadius: 10, transform: [{scale: 0.9}]  }}
                                                        activeDotStyle={{ backgroundColor: "#f1f1f1", transform: [{scale: 1.1}] }}
                                                        containerStyle={{ gap: 5, zIndex: 10000, position: 'absolute', top: 10}}			
            />
            <Carousel
                onProgressChange={progress}
                height={target_height}
                width={target_width}
                // autoPlay
                // autoPlayInterval={10000}
                data={data}
                renderItem={({item}) => {
                    
                    return(
                        item.type =='i' ? <FastImage
                        source={{ uri: item.content }}
                        style={{ flex: 1 }}
                        resizeMode='cover'
                    /> : <View style={{flex: 1, }}>
                        <Video 
                            style={{flex: 1, backgroundColor: 'black'}}
                            source={{
                                uri: item.content
                            }}
                            paused={false} // <-- ADD THIS
                            resizeMode='contain' // optional: better filling the container
                            repeat // optional: loop video

                        />
                    </View>
                    )
                }}
            />
        </Box>
        
        </Box>

        <BottomSheet 
        ref={refBottomSheet}
        snapPoints={[60,  currentHeight * 0.4]}
        enableContentPanningGesture={false}
        onChange={(index, position, type: SNAP_POINT_TYPE) => {
            console.log(index, position)
            if(index == 0){
                setArrowType('down')
            }else 
                setArrowType('up')
        }}
        handleComponent={() => {


            return (
            <Pressable 
            onPress={() => {
                refBottomSheet.current?.snapToIndex(
                    arrowType == 'up' ? 0 : 1
                )
            }}
            p={5} maxHeight={60}  paddingY={'full'} borderBottomColor={'gray.300'} borderBottomWidth={1} flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
                    <Text color="white" fontSize={18} fontWeight="bold">{portfolio.name}</Text>
                    <HugeiconsIcon icon={
                        arrowType  == 'up' ? ArrowUp01Icon : ArrowDown01Icon} color='white' size = {18}/>
            </Pressable>)
        }}

        backgroundStyle={{
            backgroundColor: 'rgba(0,0,0,0.6)'
        }}
        
        maxDynamicContentSize={currentHeight * 0.4}
        >
            
            {/* <BottomSheetScrollView style={{padding: 20}}> */}
                <BottomSheetScrollView style={{padding: 20}} onLayout={() => {
                setTimeout(() => {
                    refBottomSheet.current?.expand()
                }, 400)
            }}>
                <Text color="gray.200" fontSize={16} mt={2}>{parseDescriptionToTextElements(portfolio.description_full)}</Text>
                {/* <Button mt={4} onPress={handleClose} borderRadius={10} backgroundColor="blue.400">
                Close
                B
                </Button> */}

                {/* <LinearGradient
                    colors={['rgba(0,0,0,0.3)', 'rgba(0,0,0,0.3)',]}
                    start={{ x: 0.5, y: 0 }}
                    end={{ x: 0.5, y: 1 }}
                    style={StyleSheet.absoluteFill}
                /> */}
                <View height={verticalScale_(100)}  />
                </BottomSheetScrollView>
            {/* </BottomSheetScrollView> */}
            
            
        </BottomSheet>
        </Animated.View>

      </Animated.View>
      </GestureDetector>
    </Portal>
  );
};

export default React.memo(PortfolioExpansion);



import { Linking, StyleSheet } from 'react-native';

export function parseDescriptionToTextElements(description: string) {
  const parts = [];
  const linkRegex = /<a\s+href="([^"]+)"[^>]*>(.*?)<\/a>/gi;
  let lastIndex = 0;
  let match;

  while ((match = linkRegex.exec(description)) !== null) {
    const [fullMatch, href, linkText] = match;

    // Текст перед ссылкой
    if (match.index > lastIndex) {
      parts.push(description.slice(lastIndex, match.index));
    }

    // Ссылка
    parts.push(
      <Text key={href + match.index} onPress={() => Linking.openURL(href)} style={{color: 'rgb(10,132,255)'}}>
        {linkText}
      </Text>
    );

    lastIndex = match.index + fullMatch.length;
  }

  // Остаток текста после последней ссылки
  if (lastIndex < description.length) {
    parts.push(description.slice(lastIndex));
  }

  return parts;
}
